<style scoped lang="less">
	// .upload-demo {
	// 	position: relative;
	// 	height: 20vh;
	// 	left: 0;
	// }
</style>


<template>
	<div>
		<!-- action="http://192.168.88.136/api/TrainPower/UploadTrainImages" -->
		<el-upload :file-list="filelists" ref="upload" :action="baseurl"
			list-type="picture-card" accept=".png,.jpg" :on-preview="handlePictureCardPreview" :on-success="handleSuccess"
			:on-remove="handleRemove" :headers="{ 'Authorization': token }">
			<i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog :show-close="false" :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
	</div>
</template>

<script>
	import {
		postDeleteImages
	} from "@/request/api/trainroom/trainroom.js";
	import {
		setbaseurl
	} from "@/utils/utils.js"
	export default {
		props: {
			filelist: Array,
		},
		data() {
			return {
				dialogImageUrl: "",
				dialogVisible: false,
				disabled: false,
				filelists: [],
				baseurl:"",
				token:"Bearer "+localStorage.getItem("token")
			};
		},
		mounted() {
			this.baseurl = setbaseurl() + '/TrainPower/UploadImages'
			this.filelists = this.filelist;
		},
		watch: {
			filelist(val) {
				this.filelists = val;
			},
		},
		methods: {
			// 上传文件列表
			handleSuccess(response, file, fileList) {
				console.log(fileList);
				var str = "";
				fileList.forEach((item) => {
					if (item.response.code == 1) {
						str += item.response.data + "#";
					}
				});
				str = str.slice(0, -1);
				// console.log(str)
				this.$store.commit("changetrainimg", str);
				// console.log(this.$store.state.trainimg)
			},

			handleRemove(file, fileList) {
				// console.log(file);
				// var str1 = "";
				// fileList.forEach((item) => {
				//   if (item.response.code == 1) {
				//     str1 += item.response.data + "#";
				//   }
				// });
				// str1 = str1.slice(0, -1);
				// this.$store.commit("changeTrainPowerimg", str1);

				let fromimgdata = new FormData();
				fromimgdata.append("sx_tp_guid", file.sx_tp_guid);
				fromimgdata.append("filePath", file.response.data);
				postDeleteImages(fromimgdata).then((res) => {
					this.$message({
						message: res.data.msg,
						type: "success",
					});
					this.$store.commit("changetrainimg", "");
				});
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
		},
	};
</script>

<style>
</style>
